export default {
    // 上半部分
    login: "登錄",
    register: "註冊",
    center: "管理中心",
    signout: "登出",
    quoteCart: "報價車",
    shoppingCart: "購物車",
    goQuoteCart: "去報價車",
    goShoppingCart: "去購物車",
    nothing: "您還沒有選擇商品，快去選購吧！",
    goLogin1: "您還未登錄，請先",
    goLogin2: "登錄！",
    totalNum: "共 {num} 件商品",
    total: "總計：",
    main: "首頁",
    about: "關於我們",
    culture: "企業文化",
    news: "最新消息",
    contact: "聯繫我們",
    service: "其他服務",
    partner: "合作商戶",
    // js部分
    confirmMsg: "是否退出賬戶？",
    signoutSucc: "登出成功！",
    delSucc: "刪除商品成功！",
    // 下半部分
    placeholder: '請輸入商品關鍵字',
}